import { createAction, props } from '@ngrx/store';

export const OpenCheckbooksSidenav = createAction('[Checkbooks: Sidenav]: Sidenav Opened');

export const CloseCheckbooksSidenav = createAction('[Checkbooks: Sidenav]: Sidenav Closed');

export const OpenCheckbookDetailsSidenav = createAction('[Checkbooks: Sidenav]: Open Checkbook Details Sidenav');

export const AssignCheckbook = createAction(
  '[Checkbooks: Sidenav]: Assign Checkbook',
  props<{ assignCheckbook: boolean }>(),
);
